import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
    Box,
    Alert
} from '@mui/material';

const LoginDialog = ({ open, onClose, onLoginSuccess }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
        setError(null);
        setLoading(true);
        try {
            const API_BASE = import.meta.env.VITE_API_BASE_URL || '/api';
            const response = await fetch(`${API_BASE}/auth_login.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });
            const data = await response.json();
            console.log("Login Response:", data);

            if (data.status) {
                localStorage.setItem('x2infotech_token', data.token);
                localStorage.setItem('x2infotech_user', JSON.stringify(data.user));
                onLoginSuccess();
                onClose();
            } else {
                setError(data.message || 'Login failed');
            }
        } catch (err) {
            setError('Could not connect to server');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ textAlign: 'center', fontWeight: 700 }}>Login to X2 Team Chat</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {error && <Alert severity="error">{error}</Alert>}
                    <TextField
                        label="Email Address"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading}
                    />
                    <TextField
                        label="Password"
                        type="password"
                        fullWidth
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={loading}
                    />
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        Try <b>admin@x2infotech.in</b> / <b>admin123</b>
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ pb: 3, px: 3 }}>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleLogin}
                    disabled={loading || !email || !password}
                    sx={{ bgcolor: '#4CAF50', '&:hover': { bgcolor: '#45a049' } }}
                >
                    {loading ? 'Logging in...' : 'Login'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LoginDialog;
